module.exports = __webpack_public_path__ + "img/curve_4.f58c5a7a.png";